var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("矩阵管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/goodsList" } } },
                [_c("div", { staticClass: "div1" }, [_vm._v("平台列表")])]
              ),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("平台查看")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("平台管理")]),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: {
                model: _vm.infoForm,
                rules: _vm.infoRules,
                "label-width": "140px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关联用户", prop: "userId" } },
                [
                  _c("div", [
                    _c("div", [
                      _vm._v("姓名：" + _vm._s(_vm.infoForm.username)),
                    ]),
                    _c("div", [_vm._v("ID:" + _vm._s(_vm.infoForm.userId))]),
                    _c("div", [
                      _vm._v("电话:" + _vm._s(_vm.infoForm.userPhone)),
                    ]),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户等级" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "30%" },
                      attrs: {
                        placeholder: "请选择用户等级",
                        filterable: "",
                        clearable: "",
                        disabled: "",
                      },
                      model: {
                        value: _vm.infoForm.vipLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "vipLevel", $$v)
                        },
                        expression: "infoForm.vipLevel",
                      },
                    },
                    _vm._l(
                      _vm.dictionaries.platform_vip_level,
                      function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { staticStyle: { display: "none" } }),
              _c(
                "el-form-item",
                { attrs: { label: "平台类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "30%" },
                      attrs: {
                        disabled: "",
                        placeholder: "请选择平台类型",
                        clearable: "",
                      },
                      model: {
                        value: _vm.infoForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "type", $$v)
                        },
                        expression: "infoForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "矩阵小程序", value: "0" },
                      }),
                      _c("el-option", {
                        attrs: { label: "投流小程序", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.infoForm.type == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "平台类目", prop: "categoryIds" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "30%" },
                        attrs: {
                          disabled: "",
                          placeholder: "请选择平台类目",
                          options: _vm.categoryList,
                          props: {
                            multiple: true,
                            checkStrictly: true,
                            emitPath: false,
                          },
                          clearable: "",
                        },
                        on: { change: _vm.onChangeCategory },
                        model: {
                          value: _vm.infoForm.categoryIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "categoryIds", $$v)
                          },
                          expression: "infoForm.categoryIds",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "平台名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: {
                      disabled: "",
                      placeholder: "请输入平台名称",
                      maxlength: "15",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.infoForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "name", $$v)
                      },
                      expression: "infoForm.name",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "状态", prop: "status" } }, [
                _c(
                  "div",
                  {
                    style: {
                      color:
                        _vm.infoForm.statusLabel == "已上线"
                          ? "#12AB62"
                          : "red",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.infoForm.statusLabel) + " ")]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "平台图片", prop: "logoUrl" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "120px", height: "120px" },
                    attrs: { src: _vm.infoForm.logoUrl },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.logoUrl)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "平台简介", prop: "intro" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    attrs: {
                      disabled: "",
                      type: "textarea",
                      placeholder: "请输入平台简介",
                      maxlength: "120",
                      "show-word-limit": "",
                      rows: 5,
                    },
                    model: {
                      value: _vm.infoForm.intro,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "intro", $$v)
                      },
                      expression: "infoForm.intro",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "平台管理员电话", prop: "adminPhone" } },
                [
                  _c(
                    "div",
                    [
                      _c("el-input", {
                        staticStyle: { width: "30%" },
                        attrs: { disabled: "", placeholder: "请输入电话" },
                        model: {
                          value: _vm.infoForm.adminPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.infoForm, "adminPhone", $$v)
                          },
                          expression: "infoForm.adminPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "管理员身份证", prop: "adminIdCardFront" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "300px", height: "150px" },
                    attrs: { src: _vm.infoForm.adminIdCardFront },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.adminIdCardFront)
                      },
                    },
                  }),
                  _c("el-image", {
                    staticStyle: {
                      width: "300px",
                      height: "150px",
                      "margin-left": "18px",
                    },
                    attrs: { src: _vm.infoForm.adminIdCardContrary },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.adminIdCardContrary)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "营业执照" } },
                [
                  _c("el-image", {
                    staticStyle: { width: "300px", height: "150px" },
                    attrs: { src: _vm.infoForm.businessLicense },
                    on: {
                      click: function ($event) {
                        return _vm.look(_vm.infoForm.businessLicense)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                width: "10%",
                "text-align": "center",
                "padding-bottom": "20px",
              },
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.back()
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            visible: _vm.dialogUser,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUser = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("用户列表"),
          ]),
          _c("div", { staticClass: "dialog-search" }, [
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入用户信息", clearable: "" },
                  model: {
                    value: _vm.keywords,
                    callback: function ($$v) {
                      _vm.keywords = $$v
                    },
                    expression: "keywords",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.getfindVipCustomerPage },
                  },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  staticStyle: {
                    width: "100%",
                    "margin-top": "20px",
                    "margin-left": "10px",
                  },
                  attrs: {
                    border: "",
                    data: _vm.tableData,
                    "tooltip-effect": "dark",
                  },
                  on: { "row-click": _vm.rowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "select", width: "55" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: scope.row.id },
                                model: {
                                  value: _vm.radioIdSelect,
                                  callback: function ($$v) {
                                    _vm.radioIdSelect = $$v
                                  },
                                  expression: "radioIdSelect",
                                },
                              },
                              [_vm._v(" ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "用户ID", prop: "id" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "用户昵称",
                      prop: "username",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phone",
                      label: "电话号码",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vipLevelName",
                      label: "用户等级",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right", "margin-top": "10px" } },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.page,
                      "page-sizes": [10, 20, 30, 40],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "60px", "text-align": "center" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "30px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.submit },
                    },
                    [_vm._v("确认")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogUser = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("平台查看")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }